import { useState, type ReactNode } from 'react';
import { Alert } from 'components/common';
import { useUser } from 'libs';

interface RevokedProAccessBrokerageBannerProps {
  children?: ReactNode;
  isDismissable?: boolean;
}

const RevokedProAccessBrokerageBanner = ({
  children = null,
  isDismissable = true,
}: RevokedProAccessBrokerageBannerProps) => {
  const user = useUser();
  const [isOpen, setIsOpen] = useState(true);

  if (!user.features.has_brokerage || !user.brokerage?.setting_revoke_pro_access || user.features.is_pro || !isOpen)
    return null;

  return (
    <Alert
      isDismissable={isDismissable}
      testId="revoked-pro-access-brokerage-banner"
      variant="error"
      onClose={() => setIsOpen(false)}
    >
      {children || (
        <div className="fw-bold text-black">
          Access to Platinum features has been suspended for {user.brokerage.name}. Please contact your team admins or
          Customer Success for further information.
        </div>
      )}
    </Alert>
  );
};

export default RevokedProAccessBrokerageBanner;
